export default __webpack_public_path__ + "fd93d3beb4ccc7246f764386f9f46c3d.png";